export default __webpack_public_path__ + "static/media/placeholder-card.064b1c70.svg";